// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__195GW","savePackageButton":"ClientWallet_savePackageButton__3BIgZ"};